import React, { useEffect, useState, Fragment, useReducer } from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { hashHistory } from 'react-router';
import SqftFeaturesPopupApplyButton from "./sqftFeaturesPopupApplyButton";
import { changeSqftFeaturesPopup } from "../../../actions/sqftFunctions";
import SqftFeaturesPopupBody from "./sqftFeaturesPopupBody";
import { getOversizedFeatureGroup, getParsedSqftData, getSimilarFeatureGroup } from "./parseSqftData";
import { removeFromCart, setCameFromPage } from "../../../actions/actionFunctions";
import AllFeaturesChecker from "../../visComponents/allFeaturesChecker";
import MaterialSpinner from "../../ui/materialSpinner";
import workspace from "../../sqft/components/canvas/core/workspace";
import {getCurrentLayout} from "../../appLayout";

const SqftFeaturesPopup = (props) => {
  const { changeSqftFeaturesPopup, sqftFeaturesPopup, intl, fabricatorData, sqftFromFeature, cartItems, setCameFromPage,
    stonePricing, quotes, removeFromCart } = props;
  const { opened, sqftPassedData } = sqftFeaturesPopup;
  const [parentsLists, setParentsLists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  const edgesFeatureGroup = opened ? getSimilarFeatureGroup("edges") : null;
  const edgesReceived = !edgesFeatureGroup || edgesFeatureGroup.part.allFeaturesReceived;
  const oversizedFeatureGroup = opened ? getOversizedFeatureGroupFromQuotes() : null;
  const oversizedReceived = !oversizedFeatureGroup || oversizedFeatureGroup.allFeaturesReceived;
  const featureGroupsToReceive = [
    !edgesReceived && edgesFeatureGroup,
    !oversizedReceived && oversizedFeatureGroup && {part: oversizedFeatureGroup},
  ].filter(Boolean);
  const readyToRebuild = opened && sqftPassedData && workspace.intl && featureGroupsToReceive.length === 0;

  useEffect(() => {
    if (readyToRebuild) {
      setLoading(true);
      removeDeletedInSQFTFeatures();
      rebuildQuoteLists();
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sqftPassedData, edgesReceived, oversizedReceived]);

  useEffect(() => {
    if (readyToRebuild) {
      rebuildQuoteLists();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quotes]);

  const rebuildQuoteLists = () => {
    const quoteLists = quotes.map((quote, quoteIndex) => {
      return {
        quoteIndex,
        quote,
        qtCatName: quote.qtCatName,
        ...getParsedSqftData(
          quote.sqFtCalcData,
          sqftFeaturesPopup.previouslyAddedSqftFeatures,
          intl,
          fabricatorData,
          cartItems,
          sqftFromFeature,
          quoteIndex,
          quote.room,
          stonePricing,
        )
      };
    });
    setParentsLists([...quoteLists]);
  };

  function getOversizedFeatureGroupFromQuotes() {
    for (const quote of quotes) {
      const layout = getCurrentLayout(quote.room);
      const featureGroup = getOversizedFeatureGroup(quote.sqFtCalcData, layout);
      if (featureGroup) {
        return featureGroup;
      }
    }
    return null;
  }

  if (!opened) {
    return null;
  }

  const removeDeletedInSQFTFeatures = () => {
    if (sqftPassedData.removedFeatures) {
      const removedFeatures = cartItems.filter(cartItem => {
        return sqftPassedData.removedFeatures.includes(cartItem.sqftId);
      });
      removedFeatures.forEach(cartItem => removeFromCart(cartItem));
    }
  };

  const closePopup = () => {
    changeSqftFeaturesPopup({
      opened: false,
      sqftPassedData: null
    });
  };

  const backButtonClick = () => {
    setCameFromPage("materials");
    hashHistory.push("sqft");
    closePopup();
  };

  return (
    <Fragment>
      <div className="ui-popup__header">
          <span className="ui-popup__header-title">
            <FormattedMessage id="sqftFeaturesPopup.title" />
          </span>
        <button className="ui-close contract-popup__close" onClick={closePopup} />
      </div>
      {featureGroupsToReceive.length ? (
        <div className="ui-popup__body ui-popup__body--relative">
          <AllFeaturesChecker subParts={featureGroupsToReceive}
                              callBack={() => forceUpdate(1)}
                              loaderOnly={true} />
        </div>
      ) : (
        loading ? (
          <MaterialSpinner />
        ) : (
          <SqftFeaturesPopupBody parentsLists={parentsLists}
                                 setParentsLists={setParentsLists}
                                 rebuildQuoteLists={rebuildQuoteLists} />
        )
      )}
      <div className="ui-popup__footer">
        <div className="ui-popup__footer-right">
          <button className="ui-button2 ui-button2--blue" onClick={backButtonClick}>
            <FormattedMessage id="assignPopup.backButton" />
          </button>
          <SqftFeaturesPopupApplyButton parentsLists={parentsLists} closePopup={closePopup} />
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (store) => {
  const { sqftFeaturesPopup, sqftFromFeature } = store.sqftState;
  const { cartItems } = store.cartState;
  const { stonePricing } = store.serverState;
  return {
    sqftFeaturesPopup,
    sqftFromFeature,
    fabricatorData: store.fabricatorState,
    cartItems,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    stonePricing,
    quotes: store.quotesState.quotes,
    fabricatorSettings: store.fabricatorState.settings
  };
};
const mapDispatchToProps = {
  changeSqftFeaturesPopup,
  setCameFromPage,
  removeFromCart,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopup)
);
